Invitation = require 'models/invitation'

module.exports = class BoardInvitation extends Invitation
  typeName: 'BoardInvitation'



// WEBPACK FOOTER //
// ./app/scripts/models/board-invitation.coffee